import { usePopupStore } from './PopupStore';
import {
  serviceOptions as commonServiceOptions,
  MissMemberInfoControllerService,
} from '@/__generated__/CommonApi';
import { serviceOptions as frontServiceOptions } from '@/__generated__/FrontApi';
import { isBrowser } from '@/helpers/BrowserHelper';
import SessionStorage, {
  SESSION_STORAGE_KEY__OVERDUE_CRYPTO,
} from '@/services/SessionStorage';
import { observable, runInAction } from 'mobx';

export interface User {
  name: string;
  email: string;
  webId: string;
  mobilePhoneNumber: string;
  firstDonateDate: string | null; // 첫 후원일
  accumTotalAmount: number; // 누적 총 후원금액

  // 생일 (웹DB)
  birthDay: string | null; // YYMMDD
  fullBirthDay: string | null; // YYYYMMDD

  // 후원정보
  donorId: string;
}

interface CertificationStoreProps {
  user: User | null;
  missSession: any;

  // 데이터가 충분히 로딩되었는지 여부 (첫 로딩시 사용)
  loaded: boolean;
  // 토큰 갱신
  refreshJwt: () => Promise<boolean>;
  loadUserInfo: (
    isLogin?: boolean,
    accessToken?: string,
  ) => Promise<User | false>;
  isLoggedIn: () => boolean;
  logout: () => void;
}

// Store 생성
const CertificationStore = observable.object<CertificationStoreProps>({
  user: null,
  missSession: SessionStorage.getItem(SESSION_STORAGE_KEY__OVERDUE_CRYPTO),
  loaded: false,
  async refreshJwt() {
    // 세션이 없으면 취소
    if (!this.missSession) {
      runInAction(() => {
        this.loaded = true;
      });
      return false;
    }
    //소급 모듈 처리
    this.loadUserInfo();

    return false;
  },

  async loadUserInfo(isLogin, accessToken) {
    // 토큰이 없으면 취소
    if (!this.missSession) {
      runInAction(() => {
        this.loaded = true;
      });
      return false;
    }

    const encKey = JSON.parse(
      SessionStorage.getItem(SESSION_STORAGE_KEY__OVERDUE_CRYPTO) as any,
    );
    const donorId = encKey?.donorId;
    console.log('++++ loadUserInfo >>> ', donorId);
    try {
      // 회원정보 로딩
      const {
        data: _data,
        resultCode,
      } = await MissMemberInfoControllerService.MissMemberLoginInfoUsingPost({
        donorId: donorId,
        certInfo: encKey?.certInfo,
        encCert: encKey?.cert,
        publicKey: encKey?.key,
        expiry: encKey?.expiry,
      });

      const data = _data as User;
    } catch (e) {
      console.error(e);
    }

    // 로딩 완료
    runInAction(() => {
      this.loaded = true;
    });

    return false;
  },

  // 로그인 여부
  isLoggedIn() {
    return !!this.user;
  },
  logout() {
    this.user = null;
    SessionStorage.clear();
  },
});
function isSafari() {
  const ua = window.navigator.userAgent.toLowerCase();
  return (
    ua.indexOf(`safari`) >= 0 &&
    ua.indexOf(`chrome`) < 0 &&
    ua.indexOf(`android`) < 0
  );
}

// 처음 로딩때 토큰 refresh 시도하며, 사용자 정보 초기 로딩
CertificationStore.refreshJwt();

// 주기적으로 토큰 refresh (브라우저 활성 세션 유지)
setInterval(() => {
  CertificationStore.refreshJwt();
}, 1000 * 60 * 30); // 30분 간격

// axios response 인터셉터
if (isBrowser) {
  [commonServiceOptions.axios, frontServiceOptions.axios].forEach(
    (instance) => {
      instance?.interceptors.response.use(
        (response) =>
          // Do something with response data
          response,
        (error) => {
          // 인증오류고, 화면쪽이면
          if (error.response?.status === 401) {
            const popupStore = usePopupStore();
            popupStore.show(`로그인 후 이용 가능합니다.`);
            CertificationStore.logout();
          }
          // Do something with response error
          return Promise.reject(error);
        },
      );
    },
  );
}

// 커스텀 훅 정의
export const useCertificationStore: () => typeof CertificationStore = () =>
  CertificationStore;

export default CertificationStore;
